// frontend\src\services\CategoryService.js

import axiosInstance from './axiosInstance';

export const getCategories = async () => {
  try {
    const response = await axiosInstance.get('/requirement-categories/');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error.name);
    throw error;
  }
};

export async function createCategory(categoryData) {
  try {
    const response = await axiosInstance.post('/requirement-categories/', categoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating category:', error.name);
    throw error;
  }
}

export async function updateCategory(id, categoryData) {
  try {
    const response = await axiosInstance.put(`/requirement-categories/${id}/`, categoryData);
    return response.data;
  } catch (error) {
    console.error('Error updating category:', error.name);
    throw error;
  }
}

export async function deleteCategory(id) {
  try {
    await axiosInstance.delete(`/requirement-categories/${id}/`);
    return true;
  } catch (error) {
    console.error('Error deleting category:', error.name);
    throw error;
  }
}

export const updateCategoryOrder = async (categories) => {
  try {
    const response = await axiosInstance.put('/requirement-categories/update_order/', {
      categories: categories
    });
    return response.data;
  } catch (error) {
    console.error('Error updating category order:', error.response.status);
    throw error;
  }
};
